import { CANVAS_RENDER_SCALE } from './canvas-pnl-builder-template'

/**
 * @description renders avatar or text to the canvas
 * @param {CanvasRenderingContext2D} ctx - The canvas context
 * @param {number} x - The x coordinate
 * @param {number} y - The y coordinate
 * @param {number} r - The radius
 * @param {string} fillStyle - color of the background
 * @param {string} textFull - The full text, will be cropped if it's longer than 5 characters
 * @param {string} url - The url
 */
export const renderAvatarOrText = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
  fillStyle: string,
  textFull: string,
  url?: string,
) => {
  const scale = (value: number) => value * CANVAS_RENDER_SCALE

  // Image if present
  if (url) {
    const img = new Image()
    img.src = url
    img.crossOrigin = 'Anonymous'
    img.onload = () => {
      ctx.save()

      ctx.beginPath()
      ctx.arc(scale(x + r), scale(y + r), scale(r), 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.clip()

      ctx.drawImage(img, scale(x), scale(y), scale(r * 2), scale(r * 2))

      ctx.restore()
    }
    img.onerror = () => {
      renderLogoFallback(ctx, x, y, r, fillStyle, textFull)
    }
  } else {
    renderLogoFallback(ctx, x, y, r, fillStyle, textFull)
  }
}

export const renderLogoFallback = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
  fillStyle: string,
  textFull: string,
) => {
  const maxLength = 5
  const isLongText = textFull.length >= maxLength
  const textMax = textFull.slice(0, maxLength)
  const fontSize = r * (1 + (maxLength - textMax.length) * 0.2)
  const scale = (value: number) => value * CANVAS_RENDER_SCALE

  ctx.save()

  // Background
  ctx.beginPath()
  ctx.roundRect(scale(x), scale(y), scale(r * 2), scale(r * 2), [scale(r)])

  ctx.fillStyle = fillStyle
  ctx.fill()

  // Letters
  ctx.textAlign = 'center'
  ctx.font = `${fontSize}px Inter_Bold`

  if (isLongText) {
    const from = scale(x + r * 2 - r * 0.3) / ctx.canvas.width
    const to = scale(x + r * 2 - r * 0.1) / ctx.canvas.width

    const gradient = ctx.createLinearGradient(0, 0, ctx.canvas.width, 0)
    gradient.addColorStop(0, 'white')
    gradient.addColorStop(from, 'white')
    gradient.addColorStop(to, 'transparent')
    gradient.addColorStop(1, 'transparent')

    ctx.fillStyle = gradient
  } else {
    ctx.fillStyle = '#fff'
  }

  ctx.fillText(textMax, scale(x + r), scale(y + r + fontSize / 5.4))

  ctx.restore()
}
